<template>
    <div @mouseover="showLibrarian" class="col col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12">
        <b-card overlay
                @click="titleClick(book)"
                class="h-100"
                :img-src="getCover(book)"
                :img-alt="book.title"
                text-variant="white">
            <div class="book-header">
            <b-card-body class="card-title">
                <span class="motw_link">
                    {{ book.title }}
                </span>
            </b-card-body>
            <b-card-body class="card-subtitle">
                <a href="#"
                   class="motw_link"
                   v-for="author in book.authors"
                   @click.stop="search('authors', author)"
                   v-text="getEndComma(author)">
                </a>
            </b-card-body>
            </div>
            <div class="card-text" ref="cardText">
              <p v-if="showLibrarianName" class="font-weight-lighter font-italic">by {{ book.librarian }}</p>
                <a class="motw_link"
                   v-for="link in getFormats(book)"
                   @click.stop=""
                   :href="link.url"
                   :title="link.size">
                <img src="static/download.svg" class="download-disk"><i>{{ link.title }}</i>
                </a>
            </div>
        </b-card>
    </div>
</template>

<script>
    import {
        eventBus
    } from '../main';

    export default {
        data() {
            return {
                showLibrarianName: false
            }
        },
        props: ['book'],
        methods: {
            readableBytes(bytes) {
                var i = Math.floor(Math.log(bytes) / Math.log(1024)),
                    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + sizes[i];
            },
            titleClick(book) {
                this.$emit('titleClick', book)
            },
            getEndComma(author) {
                if (author === this.book.authors[this.book.authors.length - 1]) {
                    if (this.book.authors.length < 5) {
                        return author
                    } else {
                        return "et al."
                    }
                } else if (this.book.authors.indexOf(author) < 4) {
                    return `${author}, `
                } else {
                  return ""
                }
            },
            getModalHeader(book) {
                let authors = ""
                for (let author of book.authors) {
                    authors += this.getEndComma(author)
                }
                return `"${book.title}" by ${authors}`
            },
            search(field, query) {
                this.$store.state.searchQuery = {
                    'endpoint': `/search/${field}/${query}`,
                    'status': `${field}: ${query}`
                }
                eventBus.$emit('reloadSearch')
            },
            getFormats(book) {
                let f = [];
                for (let frm of book['formats']) {
                    let url = book.library_url + frm.dir_path + frm.file_name
                    let title = frm.format.toUpperCase() + ", ";
                    f.push({
                        url: url,
                        title: title,
                        size: this.readableBytes(frm.size)
                    });
                }
                f[f.length - 1].title = f[f.length - 1].title.slice(0, -2)
                return f
            },
            getCover(book) {
                return book.library_url + book.cover_url
            },
            showLibrarian() {
                this.showLibrarianName = true;
                setTimeout(() => this.showLibrarianName = false, 2000);
            }
        },
    }
</script>

<style scoped>
    .col {
        padding-left: 2px;
        padding-right: 2px;
        padding-bottom: 2px;
        padding-top: 2px;
    }

    .card {
        background-image: url("data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==")
    }

    .card-body {
        padding: 0px;
    }

    .card-text,
    .card-title,
    .card-subtitle {
        font-weight: bold;
        font-size: 1.0em;
        background: black;
        margin: 0px;
        padding-top: 6px;
        padding-right: 3px;
        padding-left: 6px;
        opacity: 0.95;
    }

    .card-title {
        /* font-size: 1.2em; */
        font-style: italic;
    }

    .card-subtitle {
        font-size: 1.1em;
        opacity: 0.9;
        /*     font-style: italic; */
    }

    .book-header {
        margin: 0.5em 0 0 0
    }

    .card-text {
        width: 100%;
        position: absolute;
        bottom: 0;
    }

    .key_par {
        font-weight: bold;
    }

    .val_par {
        font-weight: normal;
    }

    .darrow {
        text-decoration: underline;
        font-weight: bold;
        font-size: 3em;
    }
</style>



// WEBPACK FOOTER //
// src/components/BookCard.vue